// Copyright (c) 2018 Deere & Company

export const when = (condition, interval = 500, max = 10) => {

    let count;

    count = 0;

    return new Promise((resolve, reject) => {

        /* eslint-disable consistent-return */

        const loop = () => {

            count += 1;

            if (count > max) {

                return reject(false);

            }

            try {

                const val = condition(count);

                if (val === false) {

                    setTimeout(loop, interval);

                } else {

                    resolve(val);

                }

            } catch (e) {

                setTimeout(loop, interval);

            }

        };

        /* eslint-enable consistent-return */

        loop();

    });

};



// WEBPACK FOOTER //
// ./src/shared/services/when.js